import { render } from "./ForClient.vue?vue&type=template&id=39282a03&scoped=true"
import script from "./ForClient.vue?vue&type=script&lang=js"
export * from "./ForClient.vue?vue&type=script&lang=js"

import "./ForClient.vue?vue&type=style&index=0&id=39282a03&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39282a03"]])

export default __exports__